module.exports = __webpack_public_path__ + "static/media/landing-page.51926002.webp";